import React, { useState, useEffect, Fragment } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import axiosInstance from "../../helpers/axiosInstance";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
import {useSelector,useDispatch} from "react-redux";
import { cambiasidebar,activalinkssidebar } from "../../Slicersreducers.js";
import basePerfiles from "../../views/siif/basePerfiles.js";
import { set } from "lodash";
const _=require("lodash");


const CreateLinks = (props) => {
    const  [cargando,setcargando]=useState(false);
    const  [routespermitidosest,setroutespermitidosest]=useState([]);
    const  [routesactive,setroutesactive]=useState([]);
    const  [blockuseeffect,setblockuseeffect]=useState(false)
    const activsidebar=useSelector(state=>state.miga.sidebaractiv);
    const estadolinks=useSelector(state=>state.miga.opcactsidebar);
    const [openIndex, setOpenIndex] = useState(null);

    const dispatch=useDispatch();

    const closeCollapse = (prop,key) => {
      let routespermitidos=_.cloneDeep(routespermitidosest);
      let ractive=[...routesactive];
      
      setcargando(true);
      //console.log("close colapse" + key +  prop.linkActive + routes.length);  
    
      dispatch(cambiasidebar(true)); 
      
      
      
      routespermitidos[key].linkActive=true;
      ractive[key]=true;
      
      for (let i=0 ; i<routespermitidos.length; i++)
      {
        if (i!=key)
        {
          routespermitidos[i].linkActive=false;
          ractive[i]=false;
        }
      }
      setroutespermitidosest(_.cloneDeep(routespermitidos));
      setroutesactive([...ractive]);
      dispatch(activalinkssidebar([...ractive]));
      setcargando(false);
      //console.log("close colapse-1-" +  prop.linkActive);    
      //setCollapseOpen(false);
    };
    const getCookie = (name) => {
      let matches = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
            "=([^;]*)"
        )
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    };
    const enviaformulario=()=>{
      let nit=getCookie("nid")
      let correo=getCookie("email")
      //console.log("nid y correo " + nit +correo)


      const popup = window.open('', '_blank', 'width=600,height=400');

      // Crear un formulario en la nueva ventana
      const form = popup.document.createElement('form');
      form.method = 'post';
      form.action = 'https://pagos.idea.gov.co/portalIdea/IngresoGYG.aspx'; // URL del servidor que procesará la solicitud POST

      // Crear campos de formulario y agregarlos al formulario
      const input1 = popup.document.createElement('input');
      input1.type = 'text';
      input1.name = 'nit';
      input1.setAttribute("value",btoa(nit))
      input1.type="hidden"
      form.appendChild(input1);

      const input2 = popup.document.createElement('input');
      input2.type = 'text';
      input2.name = 'usuario';
      input2.setAttribute("value",btoa(correo));
      input2.type="hidden"
      form.appendChild(input2);

      // Agregar el formulario a la nueva ventana y enviarlo automáticamente
      popup.document.body.appendChild(form);
      form.submit();
      console.log(form)
    }
    useEffect(()=>{
      console.log("sidebar useefect routes");
      
      let routes = props.routes.filter(r => r.profile.includes("transaccion"));
      let routesvisible=routes.filter(item=>!item.invisible);
      let routespermitidos=[];
      let ractive=[];
      let inicio=true;
      /*if(routesactive.length>0){
        inicio=false;
      }*/
      console.log(routesvisible)
      console.log(props.permisos);
      if(inicio){
        routesvisible.map((item)=>{
          let posicionpermiso=-1;
          for(let i=0;i<props.permisos.length;i++){
            if(props.permisos[i].name==item.name){
              posicionpermiso=i;
              i=props.permisos.length;
            }
          }
          
          if(posicionpermiso==-1){
            routespermitidos.push(item);
            
            ractive.push(false);
          }else{
            console.log("Ruta " + item.name + " permiso " + props.permisos[posicionpermiso].habil)
            if(props.permisos[posicionpermiso].habil){
              routespermitidos.push(item);
              ractive.push(false);
            }
          }
        })
        console.log(routespermitidos);
        setroutespermitidosest(_.cloneDeep(routespermitidos));
        setroutesactive([...ractive]);
        dispatch(activalinkssidebar([...ractive]));
        
      }else{
        routespermitidos=_.cloneDeep(routespermitidosest);
        ractive=[...routesactive];
        let registrado=-1;
        routesvisible.map((item,index)=>{
          let posicionpermiso=-1;
          for(let i=0;i<props.permisos.length;i++){
            if(props.permisos[i].name==item.name){
              posicionpermiso=i;
              i=props.permisos.length;
            }
          }
          if(posicionpermiso>=0){ 
            registrado=-1;
            for(let i=0;i<routespermitidos.length;i++){
              if(routespermitidos[i].name==props.permisos[posicionpermiso].name){
                registrado=i;
                i=routespermitidos.length
              }
            }
            if(registrado==-1){
              if(props.permisos[posicionpermiso].habil){
                routespermitidos.push(item);
                ractive.push(false);
              }
            }
            
          }
        })
        console.log(routespermitidos);
        setroutespermitidosest(_.cloneDeep(routespermitidos));
        setroutesactive([...ractive]);
      }
      
    },props.permisos);
    
    if(cargando==false){
      return(
        <Fragment>
          {routespermitidosest.map((item,index)=>{
              return ( 
                <>       
                {
                  item.submenu ? (
                    <>
                      <NavItem onClick={() => setOpenIndex(openIndex === index ? null : index)}
                      style={{cursor:"pointer"}}>
                        <NavLink>
                          <i>              
                            <img style={{height:"20px"}} src={estadolinks[index]?item.icon_active:item.icon}></img>
                          </i>
                          {item.name}
                        </NavLink>
                      </NavItem>
                      <Collapse isOpen={openIndex === index}>
                        {item.submenu.map((subItem, subIndex) => (
                          <NavItem key={subIndex}>
                            <NavLink to={item.layout + item.path + subItem.path} tag={NavLinkRRD}>
                              {subItem.name}
                            </NavLink>
                          </NavItem>
                        ))}
                      </Collapse>
                    </>
                  ) : (
                    <NavItem>
                      <NavLink
                        to={item.layout + item.path}
                        tag={NavLinkRRD}
                        onClick={() => closeCollapse(item, index)}
                        activeClassName={estadolinks[index] ? "active" : ""}
                      >
                        <i>
                          <img style={{height:"20px"}} src={estadolinks[index] ? item.icon_active : item.icon}></img>
                        </i>
                        {item.name}
                      </NavLink>
                    </NavItem>
                  )
                }
                </>     
              );
  
            /*
              return (
                <NavItem key={index}>
                  <NavLink
                    to={item.layout + item.path}
                    tag={NavLinkRRD}
                    onClick={() => closeCollapse(item,index)}
                    activeClassName={estadolinks[index]?"active":""}
                  >              
                    <i>              
                      <img style={{height:"20px", }} src={estadolinks[index]?item.icon_active:item.icon}></img>
                    </i> 
                    {item.name}
                  </NavLink>
                </NavItem>
              );
  
            */
          })}
          <a className="nav-link" href="#" onClick={enviaformulario}><i class="bi bi-card-heading"></i> Solicitudes y certificaciones</a>
          
        </Fragment>
      )

    }else{
      return(<Fragment></Fragment>)
    }
    
    /*
    return routes.map((prop, key) => {
      if (prop.invisible) return null
      let posicionpermiso=-1;
      for(let i=0;i<permisos.length;i++){
        if(permisos[i].name==prop.name){
          posicionpermiso=i;
          i=permisos.length;
        }
      }
      let muestraopc=false;
      if(posicionpermiso==-1){
        muestraopc=true;
      }else{
        if(permisos[posicionpermiso].habil){
          muestraopc=true;
        }
      }
      //console.log(permisos);
      if(muestraopc){
        if (opcactiv==key || activsidebar==false)
        {
          return (          
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={() => closeCollapse(prop,key)}
                activeClassName=""
              >
                {/*<i className={prop.icon} />}
                <i>              
                    <img style={{height:"20px"}} src={prop.icon}></img>
                </i>
                {prop.name}
              </NavLink>
            </NavItem>
          );
        }
        else
        {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={() => closeCollapse(prop,key)}
                activeClassName="active"
              >              
                <i>              
                  <img style={{height:"20px", }} src={prop.icon_active}></img>
                </i> 
                {prop.name}
              </NavLink>
            </NavItem>
          );
        }

      }else{
        return null
      }
      
    });*/
  };

  export default CreateLinks;